import React, { useEffect } from "react";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";

import {
  AccountInput,
  Container,
  LeftBox,
  LoginBox,
  LoginContainer,
  LoginItem,
  PasswordInput,
  SubmitButton,
  Title,
  TitleBox,
  WelCome,
} from "./index.styled";
import { useAppDispatch, useAppSelector } from "@/store";
import { loginAction } from "@/store/action/loginAction";
import { message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import MyImage from "@/components/basic/MyImage";
import { setCookie } from "@/utils/cookies";
import { items } from "@/components/container/AsidMenu/AsidMenu";
import { changeOpenKey } from "@/store/modules/globalConstans.slice";

export default function Login() {
  const dispatch = useAppDispatch();
  const navigator = useNavigate();

  // 当前侧边栏菜单展开情况
  const { openKey, selectMenuKey } = useAppSelector(
    (state) => state.globalConstans
  )

  /**
   * 监听侧边栏状态 根据上一次选中的侧边栏跳转对应的路由
   */
  const watchAsidMenuStatus = () => {
    const parentMenuKey = openKey[openKey.length - 1]

    // if (parentMenuKey) {
    //   // 没有子集
    //   const parentItem = items.find((item: any) => item.key === parentMenuKey);

    //   if (parentItem && 'children' in parentItem) {
    //     if (parentItem.children === undefined) {
    //       if ('onClick' in parentItem) {
    //         parentItem.onClick()
    //       }
    //     } else {
    //       const childItem = parentItem.children.find((item: any) => item.key === selectMenuKey[0])
    //       childItem.onClick()
    //     }
    //   }
    // } else {
    // 第一次登录系统
    navigator("/admin/dataCenter")
    dispatch(changeOpenKey(['/admin/dataCenter']))
    // }
  }

  // 设置时间
  let inFifteenMinutes = new Date(new Date().getTime() + 30 * 1000);
  const onFinish = (value: any) => {
    localStorage.setItem("userInfo", JSON.stringify(value));
    dispatch(loginAction(value)).then((res: any) => {
      localStorage.setItem("userInfoObject", JSON.stringify(res.payload.data));
      setCookie("userInfoObject", JSON.stringify(res.payload.data), {
        expires: inFifteenMinutes,
        path: "/",
      });
      if (res.payload.code === 1) {
        message.success("登录成功！");
        watchAsidMenuStatus()
      } else {
        message.error(res.payload.error);
      }
    });
  };

  useEffect(() => {
    if (localStorage.getItem("come-to-chant-token")) {
      navigator("/admin/dataCenter");
    }
  }, []);

  return (
    <Container>
      <LoginBox>
        <LeftBox>
          <TitleBox>
            <MyImage
              width={150}
              height={70}
              src={require("@/assets/img/home/bet.png")}
            />
          </TitleBox>
          <Title style={{ marginTop: 10 ,textAlign: "left" , marginLeft: 20}}>Manage System</Title>
        </LeftBox>
        <LoginContainer onFinish={onFinish} autoComplete="off">
          <WelCome style={{fontSize: 25}} >Welcome</WelCome>
          <div style={{fontSize: 16}}>Blind Box management System</div>
          <LoginItem>
            <LoginItem
              name="username"
              rules={[{ required: true, message: "Please input your account" }]}
            >
              <AccountInput
                size="large"
                placeholder="Please input your account"
                prefix={<UserOutlined />}
              />
            </LoginItem>
            <LoginItem
              name="password"
              rules={[{ required: true, message: "password enter your password" }]}
            >
              <PasswordInput
                size="large"
                placeholder="password enter your password"
                prefix={<KeyOutlined />}
              />
            </LoginItem>
            <LoginItem>
              <SubmitButton type="primary" htmlType="submit">
                Login
              </SubmitButton>
            </LoginItem>
          </LoginItem>
        </LoginContainer>
      </LoginBox>
    </Container>
  );
}
